/**
 *
 * ResourcePageHighlights
 *
 */

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import _classNames from 'classnames';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import { makeStyles, useTheme } from '@material-ui/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import useSiteCopySelector from 'components/useSiteCopySelector';

const useStyles = makeStyles(theme => ({
  container: {
    position: 'relative',
    display: 'flex',
    flexWrap: 'wrap',
    marginTop: 10,
    [theme.breakpoints.down('md')]: {
      padding: '0 18px !important',
    },
  },
  item: {
    backgroundColor: '#F8F9F9',
    padding: '6px 12px',
    borderRadius: 20,
    margin: 4,
  },
  more: {
    cursor: 'pointer',
  },
}));
const ResourcePageHighlights = ({
  audience = [],
  highlights = [],
  tags = [],
}) => {
  const theme = useTheme();
  const classes = useStyles();
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'));
  const [resourceItemPageSiteCopy] = useSiteCopySelector([
    'resource-item-page',
  ]);
  const [opened, setOpened] = useState(false);
  const fullHighlights = [];
  if (!_isEmpty(audience))
    audience.forEach(el => {
      if (_get(el, 'fields.reviewStatus') === 'Accepted')
        fullHighlights.push(
          _get(el, 'fields.longName') || _get(el, 'fields.name'),
        );
    });
  if (!_isEmpty(tags))
    tags.forEach(el => {
      if (_get(el, 'fields.reviewStatus') === 'Accepted')
        fullHighlights.push(
          _get(el, 'fields.longName') || _get(el, 'fields.title'),
        );
    });
  if (highlights) highlights.forEach(el => fullHighlights.push(el));

  if (_isEmpty(fullHighlights)) return null;

  const limit = isMobile ? 150 : 120;

  let showUntil = 0;
  const showMoreButton =
    fullHighlights.reduce((acc, value) => {
      if (acc + value.length <= limit) showUntil += 1;
      return acc + value.length;
    }, 0) > limit;
  const finalHighlights = opened
    ? fullHighlights
    : fullHighlights.slice(0, showUntil);

  return (
    <Grid item xs={12} className={classes.container}>
      {finalHighlights.map(el => (
        <Typography
          variant="overline"
          color="textPrimary"
          className={classes.item}
          key={el}
        >
          {el}
        </Typography>
      ))}
      {showMoreButton && !opened && (
        <Typography
          variant="overline"
          color="textSecondary"
          className={_classNames(classes.item, classes.more)}
          onClick={() => setOpened(true)}
        >
          {_get(resourceItemPageSiteCopy, ['pageCopy', 'highlightsMoreLabel'])}
        </Typography>
      )}
    </Grid>
  );
};

ResourcePageHighlights.propTypes = {
  audience: PropTypes.array,
  highlights: PropTypes.array,
  tags: PropTypes.array,
};

export default ResourcePageHighlights;
